import DateDB from '@demre/date-db';

const state = {
  inscrito: {},
  pruebasFase: [],
  localAsignado: {},
};

const getters = {
  pruebasInscritas(state, getters, rootState) {
    const fase = rootState.faseSeleccionada;
    return fase && state.inscrito[fase] ? state.inscrito[fase] : [];
  },
  esInscrito(state, getters) {
    return !!getters.pruebasInscritas.length;
  },
  periodoRezagado(state, getters, rootState) {
    return rootState.config[rootState.faseSeleccionada].accesoRezagado;
  },
  tipoAccesoEspecial(state, getters, rootState) {
    return window.DATA.postulante.tipoAccesoEspecial[rootState.faseSeleccionada];
  },
  localAsignado(state, getters, rootState) {
    const fase = rootState.faseSeleccionada;
    const fspCodigo = state.localAsignado.local ? state.localAsignado.local.fspCodigo : -1;
    return state.inscrito[fase] && fase == fspCodigo ? state.localAsignado.local : null;
  },
  fechaInicioInscripcion(state, getters, rootState) {
    const date = new DateDB(rootState.config[rootState.faseSeleccionada]?.inicioProceso); 
    return `${date.format('HH:mm') } horas del ${date.format('DD de MMMM').toLowerCase()}`;
  },
  fechaFinInscripcion(state, getters, rootState) {
    const date = getters.tipoAccesoEspecial == 'rezagado' ? new DateDB(rootState.config[rootState.faseSeleccionada]?.finRezagado) : new DateDB(rootState.config[rootState.faseSeleccionada]?.finInscripcion);
    return date.format('HH:mm horas del DD de MMMM de YYYY').toLowerCase();
  },
};

const mutations = {
  setInscrito: (state, inscrito) => state.inscrito = inscrito,
  setInscritoFase(state, inscrito) {
    const pruebas = JSON.parse(JSON.stringify(state.inscrito)); // se hace esto para activar la reactividad de inscrito
    pruebas[this.state.faseSeleccionada] = inscrito;
    state.inscrito  = pruebas;
  },
  setPruebasFase(state, data) {
    state.pruebasFase = data;
  },
  setLocalAsignado: (state, local) => state.localAsignado = local,
};

export default {
  state,
  getters,
  mutations
};
